/** Column ID for the actions (Add Column "+") column */
export const ACTIONS_COLUMN_ID = 'actions';
/** Special value used to include blank/empty values in filters */
export const INCLUDE_BLANKS_VALUE = '__INCLUDE_BLANKS__';
/** Special value used to exclude blank/empty values in filters */
export const REMOVE_BLANKS_VALUE = '__REMOVE_BLANKS__';
/** Firestore caps a query at 30 disjunctions in disjunctive normal form. Filter columns
 *  multiply: an `in` of M values with an `array-contains-any` of N values costs M × N.
 *  What the client can count is a lower bound on the real cost: for a user without
 *  `formsRead`/`formsWrite`, `functions/main/src/workers/listFormVersionsDocs.ts` adds an
 *  access-group `array-contains-any` of its own, and that clause multiplies in too. */
export const FIRESTORE_MAX_DISJUNCTIONS = 30;

